import React from 'react';
import { usePublicSettings } from '@/hooks/usePublicSettings';

const HomeImage = () => {
  const { config } = usePublicSettings();
  
  const imageSettings = config.home_image_settings || {
    imageUrl: '',
    altText: '',
    caption: '',
    size: 'medium' as const
  };
  const { imageUrl, altText, caption, size } = imageSettings;
  
  if (!imageUrl) {
    return null;
  }
  
  const getSizeClasses = () => {
    switch (size) {
      case 'small':
        return 'max-h-48';
      case 'large':
        return 'max-h-96';
      default: // medium
        return 'max-h-64';
    }
  };
  
  return (
    <section className="mb-6 relative z-10">
      <div className="flex flex-col items-center space-y-4">
        <img 
          src={imageUrl}
          alt={altText || 'Home image'}
          className={`w-full ${getSizeClasses()} object-cover rounded-xl`}
          onError={(e) => {
            e.currentTarget.style.display = 'none';
          }}
        />
        {caption && (
          <p className="text-center text-muted-foreground text-sm leading-relaxed">
            {caption}
          </p>
        )}
      </div>
    </section>
  );
};

export default HomeImage;